import { Link } from "react-router-dom";
// import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa'
import React from "react"; 

function Copyright() {
  const currentYear = new Date().getFullYear();
  return (
    <div className="bg-[#e3daf5] flex flex-col sm:flex-row flex-wrap gap-3 items-center justify-between w-[calc(100%+24px)] sm:-ml-3 sm:-mb-3 px-6 py-3">
      <div>&copy;{currentYear} Copyright, All Rights Reserved.</div>
      <ul className="flex gap-3 m-0">
        <li>
          <Link
            href={"/"}
            className=" w-10 h-10 text-xl border border-[#A3A3A3] text-primary rounded-full flex justify-center items-center hover:bg-[#eee] hover:text-primary"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 320 512"
            >
              <path d="m279.14 288 14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
            </svg>
          </Link>
        </li>
        {/* Other social media icons remain unchanged */}
      </ul>
    </div>
  );
}

export default Copyright;
